module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch20"
    }
  }, [_c('b', [_vm._v("Bathroom Break")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("According to one study, a toilet has 49 germs per square inch. A desktop has 20,961.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Toilet paper was first produced on rolls in the 1870s, but they didn’t become popular until the 1900s.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("King Louis XIV had more than 250 personal chamber pots in and around the Palace of Versailles.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Britain’s Prince Charles owns a collection of toilet seats.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Emperor Vespasian introduced pay toilets to Rome in the first century AD.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Golfers Walter Hagen and Joe Kirkwood once played a round in downtown Tijuana, Mexico, using the toilet in their hotel room as the 18th hole.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("British government toilet paper used to be stamped with “Govt. Property, Now Wash Your Hands.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In Australia, outhouses are called “dunnies.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The Spike Jones Orchestra used an instrument called the latrinophone—a toilet seat with strings.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Montana’s Cow Pasture Open golf tournament includes a toilet-seat hole.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Liberace owned a retracting toilet that sank into the bathroom floor.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Jack Nicholson has a rattlesnake embedded in his toilet seat.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("During the 1790s, the White House lavatory consisted of an outdoor wooden privy. In 1801, Thomas Jefferson had two outhouses installed, one at each end of the house.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Thirty-three percent of Americans flush the toilet while still sitting on it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b417ed74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter20.vue
// module id = 132
// module chunks = 0